import { createContext } from "react";

export interface ITableWindowWrapperContext {
  outerElement: HTMLElement | null;
}

export const TableWindowWrapperContext =
  createContext<ITableWindowWrapperContext>({
    outerElement: null,
  });
